import {Observable, Subscription} from "rxjs";

export function asPromise<T>(observable: Observable<T>): Promise<T> {
  let resolver = (subsription: Subscription, resolve: Function, result: T) => {
    resolve(result);
    unsubscribe(subsription);
  };
  let rejecter = (subsription: Subscription, reject: Function, error: any) => {
    reject(error);
    unsubscribe(subsription);
  };

  return new Promise((resolve, reject) => {
    let subscription = observable.subscribe(
      result => {
        resolver(subscription, resolve, result);
      },
      error => {
        rejecter(subscription, reject, error);
      }
    );
  });
}

export function unsubscribe(sub: Subscription){
  if (!sub) {
    return;
  }

  if (sub.closed) {
    return;
  }

  sub.unsubscribe();
}
